import { environment } from 'src/environments/environment';
import { RestDialogComponent } from './../../auth/login/rest-dialog/rest-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RestService } from './../../services/rest.service';
import { FormControl, FormGroup, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { faCalendar, faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import { GuiService } from 'src/app/services/gui.service';
import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import {Router} from "@angular/router";
import { driver } from "driver.js";
import { PopupModalComponent } from '../shared/popup-modal/popup-modal.component';
import { NotificationService } from 'src/app/services/notification.service';
import { TimeChallengeService } from 'src/app/services/time-challenge.service';

@Component({
  selector: 'vex-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  environment = environment.baseURL;
  bannerSlides;
  placeholderSlides = Array(6);
  percentage: number = 0;
  @ViewChild('swiperWorkouts') swiperRef: ElementRef;


  constructor(public guiService: GuiService, private restService: RestService, public translate: TranslateService, private dialog: MatDialog, private router: Router, public notificationService: NotificationService, public timeChallengeService: TimeChallengeService) { }

  ngOnInit() {
    this.guiService.showSpinner = false;
    if (this.guiService.userLogged && !this.notificationService.notificationUpdateStarted) {
      this.notificationService.startNotificationUpdate();
    }
    if (this.guiService.userLogged) {
      console.debug('WILL ENTER')
      this.getBanners();
      this.timeChallengeService.getLastTimeChallenge();
      this.getProgramById(this.guiService.userLogged.workoutInfo.currentProgram);
    } else {
      this.getCurrent();
    }
  }

  getProgramById(programId) {
    this.restService.postService('node', '/program-by-id', { programId: programId, userId: this.guiService.userLogged.user.id }).subscribe((ris) => {
      this.guiService.currentProgram = ris;
      this.guiService.userLogged.workoutInfo.programs[ris._id] ? null : this.createTmpProgramData(ris._id);
      this.getRadialChartPercantage();
      this.guiService.reloadProgram = false;
      localStorage.getItem('tourHomeShowed') ? null : this.startTour();
    })
  }

  getCurrent() {
    this.restService.getService('node', 'new-current').subscribe({
      next: (ris) => {
        this.guiService.userLogged = ris;
        this.guiService.originalWorkoutInfo = JSON.parse(JSON.stringify(ris.workoutInfo));
        this.ngOnInit();
        if (!this.notificationService.notificationUpdateStarted) {
          this.notificationService.startNotificationUpdate();
        }
      },
      error: () => {
        this.guiService.doLogout();
      }
    })
  }

  countWeeklyWorkout(): number | null {
    const obj = this.guiService?.currentProgram?.weeks[this.guiService?.userLogged?.workoutInfo.programs[this.guiService?.currentProgram?._id].week];
    return obj ? Object.values(obj).filter((item: { id?: any }) => item?.id !== null && item?.id !== undefined).length : null;
  }

  openModalMarkWorkout(workoutName: string, workoutId: string, day: any) {
  const week = this.guiService?.userLogged?.workoutInfo?.programs[this.guiService?.currentProgram?._id]?.week;
  const workoutStatus = this.checkWorkoutStatus(workoutId, week, day);

  const dialogRef = this.dialog.open(PopupModalComponent, {
    panelClass: 'custom-modal-home',
    disableClose: true,
    data: {
      title: workoutName,
      subTitle: workoutStatus
        ? this.translate.instant("HOME.MODAL-MARK.SUB-TITLE-UNMARK")
        : this.translate.instant("HOME.MODAL-MARK.SUB-TITLE-MARK"),
      buttonTitle: this.translate.instant("HOME.MODAL-MARK.BTN-CONFIRM"),
      closeBtnTop: true,
      callbackBtn: workoutStatus ? 'unmark' : 'mark'
    }
  });

  dialogRef.afterClosed().subscribe((dataReturned) => {
    if (dataReturned?.callback) {
      const body = {
        userId: this.guiService?.userLogged?.user.id,
        currentProgram: this.guiService.currentProgram._id,
        day,
        week,
        workoutId,
        workoutStatus: dataReturned.callback === 'mark' ? 'FORCED_COMPLETED' : 'UNCOMPLETED'
      };

      this.restService.postService('node', '/set-user-workout-info', body).subscribe((res) => {
        console.debug('SET WORKOUT INFO RESPONSE:', res);
        this.guiService.userLogged.workoutInfo = res;
        this.getRadialChartPercantage();
      });
    }
  });
}


  createTmpProgramData(programId) {
    this.guiService.userLogged.workoutInfo.programs[programId] = {
      week: 0,
      progress: {}
    }
  }

  checkWorkoutStatus(workoutId, week, day) {
    const progress = this.guiService.userLogged?.workoutInfo?.programs[this.guiService.currentProgram._id]?.progress;
    if (progress && progress["week_" + week] && (progress["week_" + week][workoutId + '_' + day]?.status === 'COMPLETED' || progress["week_" + week][workoutId + '_' + day]?.status === 'FORCED_COMPLETED')) {
      return true
    } else {
      return false
    }
  }

  workoutCompletedInWeek(){
    const week = this.guiService?.userLogged?.workoutInfo.programs[this.guiService?.currentProgram?._id].week;
    const progress = this.guiService.userLogged?.workoutInfo?.programs[this.guiService.currentProgram._id]?.progress;

    let number: number = 0;
    for(let key in progress["week_"+week]){
      if(progress["week_"+week][key] && typeof progress["week_"+week][key] === 'object' &&(progress["week_"+week][key].status === 'COMPLETED' || progress["week_"+week][key].status === 'FORCED_COMPLETED')){
        number++;
      }
    }
    return number;
  }

  getStrokeDashArray() {
    const radius = 16; // Raggio del cerchio (half della dimensione del viewBox)
    const circumference = 2 * Math.PI * radius; // Formula della circonferenza
    const dashArray = (this.percentage / 100) * circumference; // Parte di cerchio da colorare
    return `${dashArray} ${circumference}`; // Format per stroke-dasharray
  }

  getRadialChartPercantage() {
    const programObj = this.guiService?.userLogged?.workoutInfo.programs[this.guiService?.currentProgram?._id];
    !programObj.progress['week_' + programObj.week] ? programObj.progress['week_' + programObj.week] = {} : null;
    !programObj.progress['week_' + programObj.week].progress_day ? programObj.progress['week_' + programObj.week].progress_day = 0 : null;
    const progressDay = programObj.progress['week_' + programObj.week].progress_day;
    const perc = (progressDay / this.countWeeklyWorkout()) * 100;

    const maxWeek = this.guiService.currentProgram .weeks.length - 1;
    this.countWeeklyWorkout() === progressDay ?this.checkIfWeekCompleted(maxWeek) : null;
    this.goToSlide()

    this.percentage = Math.round(perc);
  }

  goToSlide() {
    const obj = this.guiService.currentProgram?.weeks[this.guiService?.userLogged?.workoutInfo.programs[this.guiService?.currentProgram?._id].week];
    const programObj = this.guiService?.userLogged?.workoutInfo.programs[this.guiService?.currentProgram?._id];
    let number: number = 0;
    let index = 0;

    for(let element in obj){
      if(obj[element].id){
        const progress = programObj.progress['week_' + programObj.week][obj[element].id+'_'+index]
        if(progress && progress.status.includes('COMPLETED')){
          number++;
        }else{
          break;
        }
      }
      index++
    }

    setTimeout(() => {
      this.swiperRef?.nativeElement.swiper.slideTo(number, 500);
    }, 1000);
  }

  goToWorkout(workoutId, colorClass, dayIndex) {
    localStorage.setItem('dayIndex', dayIndex)
    localStorage.setItem('colorClass', colorClass)
    this.router.navigate(['main/workout-detail'], {
      queryParams: { id: workoutId, colorClass: colorClass }
    });
  }

  checkIfWeekCompleted(maxWeek) {
    const originalProgramId = this.guiService.originalWorkoutInfo.currentProgram;
    const currentProgramId = this.guiService.userLogged.workoutInfo.currentProgram;
    const originalWeek = this.guiService.originalWorkoutInfo.programs[originalProgramId].week;
    const currentWeek = this.guiService.userLogged.workoutInfo.programs[currentProgramId].week;

    if (originalProgramId === currentProgramId && originalWeek === currentWeek && (currentWeek + 1) <= maxWeek) {

      const body = {
        userId: this.guiService?.userLogged?.user.id,
        currentProgram: this.guiService.currentProgram._id,
        day: 0,
        week: this.guiService.userLogged.workoutInfo.programs[this.guiService?.currentProgram?._id].week + 1,
        workoutId: 'start_week',
        workoutStatus: 'START_WEEK'
      };
      this.restService.postService('node', '/set-user-workout-info', body).subscribe((ris) => {
        this.getCurrent();
      })
    }
  }

  startTour(): void {
    localStorage.setItem('tourHomeShowed', 'true')
    const day = this.guiService.userLogged.workoutInfo.programs[this.guiService?.currentProgram?._id].day ?? 0;

    const driverObj = driver({
      showProgress: true,
      allowClose: true,
      steps: [
        { element: '.week-progress', popover: { title: this.translate.instant('TUTORIALS.home.progressTitle'), description: this.translate.instant('TUTORIALS.home.progressDescription'), side: "bottom" } },
        { element: '.workout-program', popover: { title: this.translate.instant('TUTORIALS.home.programTitle'), description: this.translate.instant('TUTORIALS.home.programDescription') } },
        { element: '.change-program-btn', popover: { title: this.translate.instant('TUTORIALS.home.changeProgramTitle'), description: this.translate.instant('TUTORIALS.home.changeProgramDescription') } },
        { element: '.change-week-btn', popover: { title: this.translate.instant('TUTORIALS.home.changeWeekTitle'), description: this.translate.instant('TUTORIALS.home.changeWeekDescription') } },
        { element: '.workout-slide-'+day, popover: { title: this.translate.instant('TUTORIALS.home.startTitle'), description: this.translate.instant('TUTORIALS.home.startDescription') } },
        { element: '.paginator-tutorial-placeholder', popover: { title: this.translate.instant('TUTORIALS.home.scrollTitle'), description: this.translate.instant('TUTORIALS.home.scrollDescription') } },
        { element: '.banner-slider', popover: { title: this.translate.instant('TUTORIALS.home.wellnessTitle'), description: this.translate.instant('TUTORIALS.home.wellnessDescription') } },
      ]
    });

    driverObj.drive();
  }

  getBanners(){
    this.restService.postService('node', '/banner-list-active', {userId: this.guiService.userLogged.user.id, langReference: this.translate.currentLang.toUpperCase()}).subscribe((ris)=>{
      console.debug('banners:',ris);
      this.bannerSlides = ris;
    })
  }

  evaluateBannerRedirect(banner){
    console.debug(banner)
    if(banner.externalUrl){
      this.guiService.goToExternalLink(banner.redirectUrl)
    }else{
      if(banner.addonCategory || banner.addonTags ){
        sessionStorage.removeItem('addonCategory');
        sessionStorage.removeItem('addonTags');

        if(banner.addonCategory  && banner?.addonCategory !== ''){
          sessionStorage.setItem('addonCategory', banner.addonCategory);
        }
        if(banner?.addonTags && banner?.addonTags.length > 0){
          const tags = JSON.stringify(banner.addonTags);
          sessionStorage.setItem('addonTags', tags);
        }
        const route = banner.redirectUrl.split('tabs/').join("");
        this.guiService.goTo(route);
      }else{
        sessionStorage.removeItem('addonCategory');
        sessionStorage.removeItem('addonTags');
        const route = banner.redirectUrl.split('tabs/').join("");
        this.guiService.goTo(route);
      }
    }
  }

  public getWorkoutValue(workout: any): any {
    return workout?.value;
  }
}
